import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Add = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.55 5.7502C12.55 5.44644 12.3037 5.2002 12 5.2002C11.6962 5.2002 11.45 5.44644 11.45 5.7502V11.4502H5.74995C5.44619 11.4502 5.19995 11.6964 5.19995 12.0002C5.19995 12.304 5.44619 12.5502 5.74995 12.5502H11.45V18.2502C11.45 18.554 11.6962 18.8002 12 18.8002C12.3037 18.8002 12.55 18.554 12.55 18.2502V12.5502H18.25C18.5537 12.5502 18.8 12.304 18.8 12.0002C18.8 11.6964 18.5537 11.4502 18.25 11.4502H12.55V5.7502Z"
        fill={color}
      />
    </svg>
  )
})

export default Add
